import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { MemberInvoicesService } from './member-invoices.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DumbPaymentMethod } from '../membership-management/DTOs/dumb-payment-method';
import { DumbNonInvoicePaymentItem } from './DTOs/dumb-non-invoice-payment-item';
import { SubmitPaymentRequest } from './DTOs/submit-payment-request';

@Component({
  selector: 'app-member-non-invoice-payment-details',
  templateUrl: './member-non-invoice-payment-details.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class MemberNonInvoicePaymentDetailsComponent {
  constructor(private invoiceService: MemberInvoicesService,
    private blockUI: UIBlockingService,
    private notificationService: ToastNotificationService,
    private route: ActivatedRoute,
    private router: Router) {
  }
  
  paymentReasons = [{val: 1, title:'Membership Dues'},{val: 2, title:'Sponsorship'},{val: 3, title:'Accelerate Indy'},
  {val: 4, title:'Business Advocacy Committee Donation'},{val: 5, title:'Economic Development'},
  {val: 6, title:'Jacqueline Troy Inspired Fund (JTIF)'},{val: 7, title:'Other'},]

  paymentTypeCtrl = new FormControl("paymentType");
  nameOnCardCtrl = new FormControl("nameOnCard");
  cardNumberCtrl = new FormControl("cardNumber");
  cardExpirationCtrl = new FormControl("cardExpiration");
  CVVCtrl = new FormControl("cvv");
  streetCtrl = new FormControl("street");
  street2Ctrl = new FormControl("street2");
  cityCtrl = new FormControl("city");
  stateCtrl = new FormControl("state");
  zipCtrl = new FormControl("zip");
  accountNameCtrl = new FormControl("accountName");
  routingNumberCtrl = new FormControl("routingNumber");
  accountNumber1Ctrl = new FormControl("accountNumber1");
  accountNumber2Ctrl = new FormControl("accountNumber2");


  paymentInfoForm: FormGroup = new FormGroup({
    nameOnCard: this.nameOnCardCtrl,
    paymentType: this.paymentTypeCtrl,
    cardNumber: this.cardNumberCtrl,
    cardExpiration: this.cardExpirationCtrl,
    cvv: this.CVVCtrl,
    street: this.streetCtrl,
    street2: this.street2Ctrl,
    city: this.cityCtrl,
    state: this.stateCtrl,
    zip: this.zipCtrl,
    accountName: this.accountNameCtrl,
    routingNumber: this.routingNumberCtrl,
    accountNumber1: this.accountNumber1Ctrl,
    accountNumber2: this.accountNumber2Ctrl,
  });


  paymentType() { return this.paymentInfoForm.get('paymentType').value }

  nameOnCard() { return this.paymentInfoForm.get('nameOnCard').value }
  cardNumber() { return this.paymentInfoForm.get('cardNumber').value }
  cardExpiration() { return this.paymentInfoForm.get('cardExpiration').value }
  cvv() { return this.paymentInfoForm.get('cvv').value }
  street() { return this.paymentInfoForm.get('street').value }
  street2() { return this.paymentInfoForm.get('street2').value }
  city() { return this.paymentInfoForm.get('city').value }
  state() { return this.paymentInfoForm.get('state').value }
  zip() { return this.paymentInfoForm.get('zip').value }

  accountName() { return this.paymentInfoForm.get('accountName').value }
  routingNumber() { return this.paymentInfoForm.get('routingNumber').value }
  accountNumber1() { return this.paymentInfoForm.get('accountNumber1').value }
  accountNumber2() { return this.paymentInfoForm.get('accountNumber2').value }

  get grandTotal() { return this.payments.reduce((sum, current) => sum + current.amount, 0); }


  accountNumbersMatchError: boolean = false;

  paymentMethod: DumbPaymentMethod;

  payments: DumbNonInvoicePaymentItem[] = [];


  ngOnInit() {

    this.payments.push(new DumbNonInvoicePaymentItem());

    this.blockUI.start();
    this.getMemberPaymentMethod().subscribe(
      {
        next: (data) => {
          this.paymentMethod = data;
          this.resetPaymentInfoForm();
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }

  private resetPaymentInfoForm(): void {
    this.paymentInfoForm.reset();
    this.paymentInfoForm.get('paymentType').valueChanges.subscribe(val => {
      this.clearPaymentValidators();
      this.setPaymentValidators(val);
    });
    this.paymentInfoForm.patchValue({
      paymentType: 1,
    });
  }
  setPaymentValidators(val) {
    if (val == 1) {
      this.paymentInfoForm.get('nameOnCard').setValidators(Validators.required);
      this.paymentInfoForm.get('cardNumber').setValidators(Validators.required);
      this.paymentInfoForm.get('cardExpiration').setValidators(Validators.required);
      this.paymentInfoForm.get('cvv').setValidators(Validators.required);
      this.paymentInfoForm.get('street').setValidators(Validators.required);
      this.paymentInfoForm.get('city').setValidators(Validators.required);
      this.paymentInfoForm.get('state').setValidators(Validators.required);
      this.paymentInfoForm.get('zip').setValidators(Validators.required);
    }
    else if (val == 2) {
      this.paymentInfoForm.get('accountName').setValidators(Validators.required);
      this.paymentInfoForm.get('routingNumber').setValidators(Validators.required);
      this.paymentInfoForm.get('accountNumber1').setValidators(Validators.required);
      this.paymentInfoForm.get('accountNumber2').setValidators(Validators.required);
    }
    this.paymentInfoForm.get('accountName').updateValueAndValidity();
    this.paymentInfoForm.get('routingNumber').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber1').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber2').updateValueAndValidity();
    this.paymentInfoForm.get('nameOnCard').updateValueAndValidity();
    this.paymentInfoForm.get('cardNumber').updateValueAndValidity();
    this.paymentInfoForm.get('cardExpiration').updateValueAndValidity();
    this.paymentInfoForm.get('cvv').updateValueAndValidity();
    this.paymentInfoForm.get('street').updateValueAndValidity();
    this.paymentInfoForm.get('street2').updateValueAndValidity();
    this.paymentInfoForm.get('city').updateValueAndValidity();
    this.paymentInfoForm.get('state').updateValueAndValidity();
    this.paymentInfoForm.get('zip').updateValueAndValidity();
  }

  clearPaymentValidators() {
    this.paymentInfoForm.get('nameOnCard').clearValidators();
    this.paymentInfoForm.get('cardNumber').clearValidators();
    this.paymentInfoForm.get('cardExpiration').clearValidators();
    this.paymentInfoForm.get('cvv').clearValidators();
    this.paymentInfoForm.get('street').clearValidators();
    this.paymentInfoForm.get('city').clearValidators();
    this.paymentInfoForm.get('state').clearValidators();
    this.paymentInfoForm.get('zip').clearValidators();
    this.paymentInfoForm.get('routingNumber').clearValidators();
    this.paymentInfoForm.get('accountNumber1').clearValidators();
    this.paymentInfoForm.get('accountNumber2').clearValidators();

    this.paymentInfoForm.get('accountName').updateValueAndValidity();
    this.paymentInfoForm.get('routingNumber').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber1').updateValueAndValidity();
    this.paymentInfoForm.get('accountNumber2').updateValueAndValidity();
    this.paymentInfoForm.get('cardNumber').updateValueAndValidity();
    this.paymentInfoForm.get('cardExpiration').updateValueAndValidity();
    this.paymentInfoForm.get('cvv').updateValueAndValidity();
    this.paymentInfoForm.get('street').updateValueAndValidity();
    this.paymentInfoForm.get('city').updateValueAndValidity();
    this.paymentInfoForm.get('state').updateValueAndValidity();
    this.paymentInfoForm.get('zip').updateValueAndValidity();
  }

  getMemberPaymentMethod() {
    return this.invoiceService
      .getMemberPaymentMethod();
  }

  addNewPayment() {
    this.payments.push(new DumbNonInvoicePaymentItem());
  }

  removePaymentFromList(toRemove: DumbNonInvoicePaymentItem) {
    var indexInList = this.payments.indexOf(toRemove);
    if (indexInList >= 0)
      this.payments.splice(indexInList, 1);
  }



  submitPayment() {
    for (var i in this.paymentInfoForm.controls) {
      this.paymentInfoForm.controls[i].markAsTouched();
    }
    if (this.paymentType() == 2) {
      if (this.accountNumber1() != this.accountNumber2()) {
        this.accountNumbersMatchError = true;
      }
    }
    if (!this.paymentInfoForm.valid || this.accountNumbersMatchError) {
      return;
    }

    this.blockUI.start();
    var request = new SubmitPaymentRequest();
    request.paymentType = this.paymentType();

    request.cardNumber = this.cardNumber();
    request.cardExpiration = this.cardExpiration();
    request.cvv = this.cvv();
    request.billingStreet = this.street();
    request.billingStreet2 = this.street2();
    request.billingCity = this.city();
    request.billingState = this.state();
    request.billingZip = this.zip();
    if (this.paymentType() == 2) {
      request.nameOnAccount = this.accountName();
    }
    else {
      request.nameOnAccount = this.nameOnCard();
    }
    request.routingNumber = this.routingNumber();
    request.accountNumber1 = this.accountNumber1();
    request.accountNumber2 = this.accountNumber2();

    request.nonInvoicePayments = this.payments;
    this.invoiceService.submitNonInvoicePayment(request)
      .subscribe({
        next: (data) => {
          return this.router.navigate(['/admin-portal/member/invoice-management']);
        },
        error: (err) => {
          console.log(err);
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }
}
